import type { CloudpackConfig } from '@ms-cloudpack/common-types';
import { mergeArrayDefaults } from '@ms-cloudpack/package-utilities';

const defaultNeverExcludeDependencies = ['tslib', '@babel/runtime'];

/**
 * Checks if a package should never be excluded.
 * Uses the `neverExcludeDependencies` field in the config or the default list.
 * @param packageName Name of the package to check.
 * @param config Cloudpack configuration.
 * @returns True if the package should never be excluded.
 */
export function neverExclude(packageName: string, config: CloudpackConfig): boolean {
  // Set never exclude to the default if it is not set. Replace string '...' with default if set.
  const neverExcludeDependencies = mergeArrayDefaults(config.neverExcludeDependencies, defaultNeverExcludeDependencies);

  return neverExcludeDependencies.includes(packageName);
}
